export interface MovieCharacter {
  name: string;
  role: string;
  desc: string;
}

export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  type: string;
  rating: number;
  duration: string;
  director: string;
  language: string;
  releaseDate: string;
  cover: string;
  wide: string;
  tagline: string;
  synopsis: string;
  story: string;
  characters: MovieCharacter[];
  tags: string[];
  popularity: number;
  featured: boolean;
}

export const movies: Movie[] = [
  {
    id: "despicable-me",
    title: "神偷奶爸",
    originalTitle: "Despicable Me",
    year: 2010,
    type: "动画长片",
    rating: 8.5,
    duration: "95 分钟",
    director: "皮埃尔·柯芬 / 克里斯·雷纳德",
    language: "英语 / 国语",
    releaseDate: "2010-07-09",
    cover: "https://readdy.ai/api/search-image?query=Playful%20animated%20movie%20poster%20art%20with%20bright%20yellow%20characters%20gathered%20around%20a%20grumpy%20tall%20silhouette%20figure%2C%20warm%20sunny%20color%20palette%2C%20clean%20illustrated%20style%2C%20soft%20gradient%20background%2C%20high%20detail&width=600&height=900&seq=minion-poster-01&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Warm%20sunny%20suburban%20street%20with%20tiny%20yellow%20animated%20creatures%20running%20playfully%2C%20bright%20cheerful%20illustrated%20style%2C%20soft%20pastel%20sky%2C%20cinematic%20wide%20composition%2C%20joyful%20family%20animation%20mood&width=1600&height=900&seq=minion-wide-01&orientation=landscape",
    tagline: "世上最伟大的神偷，遇上了最麻烦的三个小家伙。",
    synopsis: "超级大坏蛋格鲁计划偷走月亮，却因为收养了三个小女孩，人生轨迹彻底改变。一群叽叽喳喳的小黄人全程跟班，笑料不断。",
    story: "格鲁是世界上最厉害的神偷，他住在堆满奇怪发明的郊区小楼里，身边围绕着一群忠诚又吵闹的小黄人。为了完成史上最大胆的计划——偷走月亮，格鲁需要先弄到缩小射线。在对手维克多的刺激下，他决定收养三个孤儿女孩玛戈、伊迪丝和艾格尼丝，用她们混进维克多的城堡。然而，三个小女孩的出现慢慢融化了格鲁冷硬的心，原本冷血的坏蛋计划，逐渐变成了一场关于家庭与成长的温暖冒险。",
    characters: [
      { name: "格鲁", role: "男主角 / 神偷", desc: "外表冷酷、内心柔软的大坏蛋，最终成为了三个女孩的爸爸。" },
      { name: "凯文", role: "小黄人队长", desc: "个子最高的小黄人，负责带队伍冲锋，可靠又爱出风头。" },
      { name: "斯图尔特", role: "小黄人成员", desc: "爱玩吉他的小黄人，随性又贪玩，总能制造意外笑点。" },
      { name: "鲍勃", role: "小黄人成员", desc: "身材最矮小的小黄人，天真可爱，抱着心爱的泰迪熊。" },
      { name: "阿格蕾丝", role: "最小养女", desc: "天真烂漫的三女儿，一句「他像独角兽」让格鲁彻底心软。" },
    ],
    tags: ["搞笑", "家庭", "温情"],
    popularity: 96,
    featured: true,
  },
  {
    id: "despicable-me-2",
    title: "神偷奶爸 2",
    originalTitle: "Despicable Me 2",
    year: 2013,
    type: "动画长片",
    rating: 8.2,
    duration: "98 分钟",
    director: "皮埃尔·柯芬 / 克里斯·雷纳德",
    language: "英语 / 国语",
    releaseDate: "2013-07-03",
    cover: "https://readdy.ai/api/search-image?query=Bright%20yellow%20animated%20creature%20wearing%20sunglasses%20on%20a%20beach%20holiday%20poster%2C%20warm%20summer%20palette%2C%20clean%20illustrated%20movie%20poster%20style%2C%20soft%20gradient%20background%2C%20playful%20family%20animation&width=600&height=900&seq=minion-poster-02&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Cheerful%20beach%20party%20under%20bright%20sun%20with%20tiny%20yellow%20animated%20characters%20dancing%2C%20warm%20tropical%20colors%2C%20illustrated%20cinematic%20wide%20scene%2C%20festive%20family%20animation%20atmosphere&width=1600&height=900&seq=minion-wide-02&orientation=landscape",
    tagline: "坏蛋退休之后，也能拯救世界。",
    synopsis: "退役当奶爸的格鲁被反恶人联盟征召，与搭档露西一起调查神秘反派，小黄人们则一边搞事一边上演爆笑日常。",
    story: "告别神偷生涯的格鲁，如今专心在家经营果酱生意，同时照顾三个女儿。平静生活被反恶人联盟打破，他被迫出山调查一种能把人变成紫色怪物的神秘血清。搭档露西·王尔德古灵精怪，两人从互相看不顺眼到渐生情愫。与此同时，渴望表现的小黄人们闹出一连串乌龙，还意外卷入了更大的阴谋。当危机降临到女儿们身上，格鲁必须再次证明，坏蛋也可以成为英雄。",
    characters: [
      { name: "格鲁", role: "男主角", desc: "从神偷转变为好爸爸，再次被卷入保护世界的任务。" },
      { name: "露西", role: "女主角 / 特工", desc: "反恶人联盟特工，热情勇敢，最终成为格鲁的伴侣。" },
      { name: "戴夫", role: "小黄人成员", desc: "爱耍酷的小黄人，一度被变成紫色小怪兽。" },
      { name: "阿格蕾丝", role: "养女", desc: "活泼可爱的三女儿，生日派对上的小主角。" },
    ],
    tags: ["搞笑", "冒险", "家庭"],
    popularity: 90,
    featured: false,
  },
  {
    id: "minions-2015",
    title: "小黄人大眼萌",
    originalTitle: "Minions",
    year: 2015,
    type: "动画长片",
    rating: 7.8,
    duration: "91 分钟",
    director: "凯尔·巴尔达 / 皮埃尔·柯芬",
    language: "英语 / 国语",
    releaseDate: "2015-07-10",
    cover: "https://readdy.ai/api/search-image?query=Historic%20adventure%20movie%20poster%2C%20a%20group%20of%20small%20bright%20yellow%20creatures%20wearing%20goggles%20marching%20toward%20a%20big%20city%2C%20warm%20golden%20light%2C%20clean%20illustrated%20poster%20art%2C%20playful%20animation%20style&width=600&height=900&seq=minion-poster-03&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Retro%20London%20city%20street%20in%20golden%20afternoon%20light%20with%20tiny%20yellow%20animated%20creatures%2C%20warm%20nostalgic%20color%20palette%2C%20illustrated%20cinematic%20wide%20scene%2C%20adventurous%20animation%20mood&width=1600&height=900&seq=minion-wide-03&orientation=landscape",
    tagline: "在世界最坏的坏蛋身边，它们永远最快乐。",
    synopsis: "小黄人们苦苦寻找最邪恶的主人，从恐龙时代一路找到六十年代的伦敦，最终追随女魔头斯嘉丽，制造了一场惊天大乱。",
    story: "从远古时代开始，小黄人们唯一的目标就是为世界上最坏的反派效力。可惜每次找到的主人都不够坏，还总被它们不小心送走。为了寻找新主人，凯文、斯图尔特和鲍勃踏上旅途，先在纽约的坏蛋大会上大闹一场，随后被史上第一位女魔头斯嘉丽·太over收编。来到伦敦后，小黄人们要为斯嘉丽偷取英国女王的王冠，关键时刻鲍勃意外拔出了石中剑，一夜间登基为国王。一场跨越六十年代英伦的疯狂冒险就此展开。",
    characters: [
      { name: "凯文", role: "小黄人队长", desc: "决心为族群找到新主人的领头者，勇敢又有责任感。" },
      { name: "斯嘉丽", role: "反派 / 女魔头", desc: "六十年代最著名的女坏蛋，以征服世界为梦想。" },
      { name: "鲍勃", role: "小黄人成员", desc: "拔出石中剑的幸运小家伙，一夜之间成为国王。" },
      { name: "赫布", role: "反派助手", desc: "斯嘉丽的丈夫兼助手，总被小黄人气得跳脚。" },
    ],
    tags: ["搞笑", "冒险", "欢乐"],
    popularity: 92,
    featured: true,
  },
  {
    id: "despicable-me-3",
    title: "神偷奶爸 3",
    originalTitle: "Despicable Me 3",
    year: 2017,
    type: "动画长片",
    rating: 7.6,
    duration: "90 分钟",
    director: "凯尔·巴尔达 / 皮埃尔·柯芬",
    language: "英语 / 国语",
    releaseDate: "2017-06-30",
    cover: "https://readdy.ai/api/search-image?query=Bright%20and%20bold%20animated%20poster%20with%20two%20similar%20silhouettes%20side%20by%20side%20and%20tiny%20yellow%20characters%20nearby%2C%20vibrant%20yellow%20and%20warm%20tones%2C%20clean%20illustrated%20movie%20poster%20style&width=600&height=900&seq=minion-poster-04&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Stylish%20retro%2080s%20village%20with%20dramatic%20sunset%20sky%20and%20tiny%20yellow%20animated%20creatures%2C%20warm%20neon%20accent%20colors%2C%20illustrated%20cinematic%20wide%20scene%2C%20playful%20adventure%20animation&width=1600&height=900&seq=minion-wide-04&orientation=landscape",
    tagline: "一家人的秘密，比月球还大。",
    synopsis: "格鲁被开除后发现自己竟有个失散多年的双胞胎兄弟德鲁，兄弟联手对付八十年代反派巴萨扎，小黄人们则酝酿一场大出走。",
    story: "因为没能抓住野心勃勃的前童星反派巴萨扎·布拉特，格鲁被反恶人联盟扫地出门。就在人生跌入谷底时，他得知自己还有一个从未谋面的双胞胎兄弟德鲁。德鲁优雅富有，还继承了家族的神偷传统，邀请格鲁一起干一票大的。兄弟俩潜入巴萨扎的据点夺回钻石，却闹出无数笑话。与此同时，对格鲁失望的小黄人们集体辞职，走向了意想不到的命运，最终在关键时刻回归。",
    characters: [
      { name: "格鲁", role: "男主角", desc: "被解雇后陷入迷茫，与兄弟重逢踏上新冒险。" },
      { name: "德鲁", role: "格鲁的双胞胎兄弟", desc: "留着金色长发、富有的家族继承人，心怀神偷梦想。" },
      { name: "巴萨扎", role: "反派", desc: "被时代抛弃的八十年代童星，用泡泡糖复仇。" },
      { name: "梅尔", role: "小黄人代表", desc: "煽动小黄人集体辞职的叛逆成员，重情重义。" },
    ],
    tags: ["搞笑", "兄弟情", "家庭"],
    popularity: 84,
    featured: false,
  },
  {
    id: "rise-of-gru",
    title: "小黄人大眼萌：神偷奶爸前传",
    originalTitle: "Minions: The Rise of Gru",
    year: 2022,
    type: "动画长片",
    rating: 7.9,
    duration: "87 分钟",
    director: "凯尔·巴尔达 / 布拉德·阿布勒森",
    language: "英语 / 国语",
    releaseDate: "2022-07-01",
    cover: "https://readdy.ai/api/search-image?query=Coming%20of%20age%20animated%20movie%20poster%20with%20a%20small%20boy%20in%20a%20black%20scarf%20and%20tiny%20yellow%20creatures%20around%20him%2C%20warm%201970s%20tones%2C%20clean%20illustrated%20poster%20art%2C%20bold%20graphic%20style&width=600&height=900&seq=minion-poster-05&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Retro%201970s%20American%20suburb%20in%20warm%20golden%20light%20with%20tiny%20yellow%20animated%20creatures%20riding%20bikes%2C%20nostalgic%20color%20palette%2C%20illustrated%20cinematic%20wide%20scene%2C%20youthful%20adventure%20mood&width=1600&height=900&seq=minion-wide-05&orientation=landscape",
    tagline: "每个传奇，都有一个开始。",
    synopsis: "故事回到格鲁的少年时代，为了加入偶像反派团体「邪恶六人组」，他和小黄人们展开了一场啼笑皆非的追梦之旅。",
    story: "十一岁的格鲁早已梦想成为世界上最厉害的超级反派。当他得知偶像团体「邪恶六人组」正在招募新成员，便满怀信心去应聘，却因为年纪太小被无情拒绝，还意外偷走了他们的珍贵宝物。一夜之间，格鲁成了六人组追杀的目标。危急关头，忠诚的小黄人们挺身而出，用一身的功夫和满脑子的馊主意救回主人。功夫大师周师父的出现，让这场少年逐梦记多了几分热血与温情。",
    characters: [
      { name: "少年格鲁", role: "男主角", desc: "满怀野心的小小反派，梦想加入邪恶六人组。" },
      { name: "凯文", role: "小黄人队长", desc: "带领小黄人远赴旧金山，守护年轻的格鲁。" },
      { name: "周师父", role: "功夫大师", desc: "隐居的功夫高手，成为格鲁的启蒙导师。" },
      { name: "贝儿", role: "邪恶六人组首领", desc: "冷酷时尚的女反派，率领六人组追捕格鲁。" },
    ],
    tags: ["搞笑", "成长", "冒险"],
    popularity: 94,
    featured: true,
  },
  {
    id: "despicable-me-4",
    title: "神偷奶爸 4",
    originalTitle: "Despicable Me 4",
    year: 2024,
    type: "动画长片",
    rating: 7.4,
    duration: "94 分钟",
    director: "克里斯·雷纳德 / 帕特里克·德拉热",
    language: "英语 / 国语",
    releaseDate: "2024-07-03",
    cover: "https://readdy.ai/api/search-image?query=Modern%20family%20animated%20movie%20poster%20with%20a%20new%20tiny%20yellow%20creature%20and%20a%20happy%20group%2C%20bright%20warm%20colors%2C%20clean%20contemporary%20illustrated%20poster%20style%2C%20soft%20gradient%20background&width=600&height=900&seq=minion-poster-06&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Cozy%20modern%20family%20home%20in%20warm%20sunlight%20with%20tiny%20yellow%20animated%20creatures%20in%20the%20yard%2C%20bright%20cheerful%20colors%2C%20illustrated%20cinematic%20wide%20scene%2C%20heartwarming%20family%20animation&width=1600&height=900&seq=minion-wide-06&orientation=landscape",
    tagline: "奶爸升级，麻烦加倍。",
    synopsis: "格鲁一家迎来了新成员小格鲁，同时也遭到老对手的报复，全家被迫隐姓埋名躲进安全屋，小黄人则变身超级英雄。",
    story: "反恶人联盟为了对抗新的威胁，将格鲁升级为特工。然而他与老对手麦心的一次正面冲突，让全家卷入危机。为了安全，格鲁一家隐姓埋名搬进豪华安全屋，开始了一段鸡飞狗跳的伪装生活。襁褓中的小格鲁继承了爸爸的反派基因，给家里添了不少乱子。与此同时，被改造成超级英雄的小黄人们身怀绝技，却依旧闯祸不断，一场保卫家庭的爆笑大战就此打响。",
    characters: [
      { name: "格鲁", role: "男主角", desc: "升级为特工的父亲，努力守护全家安全。" },
      { name: "小格鲁", role: "格鲁的幼子", desc: "拥有爸爸同款反派基因的襁褓婴儿，能量惊人。" },
      { name: "麦心", role: "反派", desc: "当年的对手再次归来，向格鲁一家展开报复。" },
      { name: "超级小黄人", role: "小黄人小队", desc: "被改造出超能力的小黄人，实力强大却依旧呆萌。" },
    ],
    tags: ["搞笑", "家庭", "超级英雄"],
    popularity: 95,
    featured: true,
  },
  {
    id: "minion-short-banana",
    title: "小黄人：香蕉总动员",
    originalTitle: "Banana",
    year: 2010,
    type: "短片",
    rating: 8.0,
    duration: "4 分钟",
    director: "凯尔·巴尔达 / 萨缪尔·图尔",
    language: "无对白",
    releaseDate: "2010-12-14",
    cover: "https://readdy.ai/api/search-image?query=Fun%20short%20film%20poster%20with%20tiny%20yellow%20creatures%20fighting%20over%20a%20banana%2C%20bright%20warm%20colors%2C%20clean%20illustrated%20comic%20style%2C%20simple%20playful%20background&width=600&height=900&seq=minion-poster-07&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Cheerful%20kitchen%20counter%20with%20tiny%20yellow%20animated%20creatures%20chasing%20bananas%2C%20bright%20warm%20illustrated%20scene%2C%20playful%20comic%20family%20animation%20mood&width=1600&height=900&seq=minion-wide-07&orientation=landscape",
    tagline: "香蕉面前，没有朋友。",
    synopsis: "一根香蕉引出的爆笑争夺战，小黄人们为了心爱的香蕉各显神通，短短几分钟笑点密集。",
    story: "对小黄人来说，世界上最美味的食物莫过于香蕉。这天，厨房里出现了一根香蕉，三只小黄人同时盯上了它。为了独占这根珍贵的香蕉，它们展开了一场你争我夺的无声大战，从厨房追到客厅，从桌面闹到地板，各出奇招。最终当香蕉被分成三段时，三个小家伙却发现——分享似乎也没那么糟。",
    characters: [
      { name: "凯文", role: "小黄人成员", desc: "想公平分香蕉的老大哥，却被伙伴们耍得团团转。" },
      { name: "鲍勃", role: "小黄人成员", desc: "用无辜眼神争夺香蕉的小可爱。" },
      { name: "斯图尔特", role: "小黄人成员", desc: "总想投机取巧的机灵鬼。" },
    ],
    tags: ["搞笑", "欢乐"],
    popularity: 76,
    featured: false,
  },
  {
    id: "minion-scouts",
    title: "小黄人：萌探出击",
    originalTitle: "Minion Scouts",
    year: 2019,
    type: "短片",
    rating: 7.5,
    duration: "4 分钟",
    director: "布拉德·阿布勒森",
    language: "无对白",
    releaseDate: "2019-12-03",
    cover: "https://readdy.ai/api/search-image?query=Adventure%20short%20film%20poster%20with%20tiny%20yellow%20creatures%20wearing%20scout%20uniforms%20in%20a%20forest%2C%20warm%20green%20and%20yellow%20tones%2C%20clean%20illustrated%20poster%20style&width=600&height=900&seq=minion-poster-08&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Sunny%20forest%20campsite%20with%20tiny%20yellow%20animated%20creatures%20in%20scout%20uniforms%2C%20warm%20green%20and%20golden%20colors%2C%20illustrated%20cinematic%20wide%20scene%2C%20playful%20outdoor%20adventure&width=1600&height=900&seq=minion-wide-08&orientation=landscape",
    tagline: "想拿徽章，先学会闯祸。",
    synopsis: "为了集齐探险徽章，小黄人们跋山涉水，用一连串乌龙诠释了什么叫「努力又好笑」。",
    story: "小黄人们参加了童子军，渴望像偶像一样集齐所有探险徽章。为了拿到最难的一枚，它们深入森林展开露营挑战：搭帐篷变成拆帐篷，生火变成灭火，徒步变成迷路。尽管一路状况百出，但小黄人们从未放弃，用笨拙却执着的方式完成了一次真正的成长冒险。",
    characters: [
      { name: "凯文", role: "小黄人队长", desc: "认真研究徽章规则，却总被队友带偏。" },
      { name: "鲍勃", role: "小黄人成员", desc: "迷路却乐观，意外发现森林美景。" },
    ],
    tags: ["搞笑", "冒险", "成长"],
    popularity: 72,
    featured: false,
  },
  {
    id: "yellow-is-new-black",
    title: "小黄人：假期奇遇",
    originalTitle: "Yellow Is the New Black",
    year: 2018,
    type: "短片",
    rating: 7.6,
    duration: "4 分钟",
    director: "萨缪尔·图尔",
    language: "无对白",
    releaseDate: "2018-11-13",
    cover: "https://readdy.ai/api/search-image?query=Holiday%20short%20film%20poster%20with%20tiny%20yellow%20creatures%20in%20bright%20winter%20outfits%2C%20warm%20cozy%20colors%2C%20clean%20illustrated%20playful%20poster%20style&width=600&height=900&seq=minion-poster-09&orientation=portrait",
    wide: "https://readdy.ai/api/search-image?query=Cozy%20winter%20town%20square%20with%20tiny%20yellow%20animated%20creatures%20in%20holiday%20outfits%2C%20warm%20festive%20lights%2C%20illustrated%20cinematic%20wide%20scene%2C%20joyful%20holiday%20animation&width=1600&height=900&seq=minion-wide-09&orientation=landscape",
    tagline: "放假了，但麻烦不放假。",
    synopsis: "一次精心策划的假期出行，被小黄人们闹成了荒诞喜剧，从机场到海滩，全程笑料升级。",
    story: "小黄人们获得了期待已久的假期，兴高采烈地准备出发。然而从收拾行李开始，一切就偏离了计划：机场安检搞成大混乱，飞机上抢座位，到了海滩又把遮阳伞当成武器。尽管旅途一波三折，小黄人们依然用天生乐观把每一天过成了欢乐节。",
    characters: [
      { name: "凯文", role: "小黄人队长", desc: "负责规划行程，却永远赶不上变化。" },
      { name: "斯图尔特", role: "小黄人成员", desc: "沉迷玩乐，制造了最多的旅途事故。" },
    ],
    tags: ["搞笑", "欢乐", "假期"],
    popularity: 70,
    featured: false,
  },
];

export const getMovieById = (id: string): Movie | undefined =>
  movies.find((m) => m.id === id);